import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const BannerCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  }

  const slides = [
    {
      image: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/logo-J9azQPgps5nEQJgcMutOHujoHWGnYU.png",
      title: "Welcome to Team CodeMe",
      subtitle: "Your gateway to innovative software solutions and dynamic marketing services",
    },
    {
      image: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/logo-J9azQPgps5nEQJgcMutOHujoHWGnYU.png",
      title: "Cutting-Edge Technology",
      subtitle: "Empowering businesses with state-of-the-art software solutions",
    },
    {
      image: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/logo-J9azQPgps5nEQJgcMutOHujoHWGnYU.png",
      title: "Strategic Marketing",
      subtitle: "Boost your brand with our integrated marketing approach",
    },
  ]

  return (
    <Slider {...settings}>
      {slides.map((slide, index) => (
        <div key={index} className="relative">
          <div className="w-full h-[400px] bg-cover bg-center" style={{ backgroundImage: `url(${slide.image})` }} />
          <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center text-center">
            <h1 className="text-5xl font-bold text-green-500 mb-4">{slide.title}</h1>
            <p className="text-xl text-gray-300">{slide.subtitle}</p>
          </div>
        </div>
      ))}
    </Slider>
  )
}

export default BannerCarousel

